/* eslint-disable react/no-danger */
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { getEmailOrCallText, emailOrCallHome } from '../../data/emailOrCallHome';

var PaymentCard = function PaymentCard(_ref) {
  var flag = _ref.flag,
      title = _ref.title,
      blurb = _ref.blurb,
      pricing = _ref.pricing,
      qualitiesTitle = _ref.qualitiesTitle,
      listOfQualities = _ref.listOfQualities,
      onPlanSelected = _ref.onPlanSelected,
      index = _ref.index;
  return /*#__PURE__*/React.createElement("div", {
    className: flag ? 'green-outline' : ''
  }, flag ? /*#__PURE__*/React.createElement("div", {
    className: "payment-card-emphasis centered-content header-text"
  }, flag) : /*#__PURE__*/React.createElement("div", {
    className: "payment-card-emphasis-empty"
  }), /*#__PURE__*/React.createElement("div", {
    className: "payment-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payment-card-title header-text ".concat(flag ? 'squared-top-radius' : '')
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("p", {
    className: "payment-card-blurb"
  }, blurb)), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-description"
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: pricing.description
    }
  }), /*#__PURE__*/React.createElement("p", null, pricing.subdescription)), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-items"
  }, /*#__PURE__*/React.createElement("h3", null, qualitiesTitle), listOfQualities.map(function (quality) {
    return /*#__PURE__*/React.createElement("div", {
      className: "payment-card-item body-text",
      key: quality
    }, /*#__PURE__*/React.createElement(Icon, {
      size: "large",
      name: "check",
      className: "payment-card-item-icon"
    }), /*#__PURE__*/React.createElement("p", null, quality));
  })), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-cta"
  }, title === 'Custom' ? /*#__PURE__*/React.createElement(Button, {
    className: "select",
    content: getEmailOrCallText(),
    onClick: emailOrCallHome
  }) : /*#__PURE__*/React.createElement(Button, {
    className: "select",
    content: "Select Plan",
    onClick: function onClick() {
      return onPlanSelected(index);
    }
  }))));
};

export default PaymentCard;